import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import organization from '@/components/organization';
import { payrollSubProjectCreate } from '@/api/payroll';
import { sysInfoFn as _sysInfoFn } from '@/api/org/per';
export default {
  components: {
    organization: organization
  },
  data: function data() {
    var _this = this;
    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          // 考勤周期的选择范围是薪资周期开始时间的前一个月到薪资周期的结束时间
          var start_date = new Date(_this.form.start_date);
          start_date.setMonth(start_date.getMonth() - 1);
          var y = start_date.getFullYear();
          var m = start_date.getMonth() + 1;
          var d = start_date.getDate();
          var start = new Date(y + '-' + m + '-' + d).getTime();
          var last = new Date(_this.form.end_date).getTime();
          return time.getTime() > last || time.getTime() < start;
        }
      },
      loading: false,
      visible: false,
      orgVisible: false,
      selectedLength: this.$t('179'),
      // 已选
      activeItem: 1,
      value1: '',
      sysInfo: {},
      pickPeople: true,
      date: '',
      attData: '',
      leaveData: '',
      disabled: false,
      employessList: [],
      form: {
        staff_list: [],
        department_list: [],
        project_id: '',
        // 主项目ID
        sub_project_name: '',
        // 子项目名称
        pay_month: '',
        // 计薪月份
        start_date: '',
        // 薪资周期开始日期
        end_date: '',
        // 薪资周期结束日期
        att_start_date: '',
        // 考勤周期开始日期
        att_end_date: '',
        // 考勤周期结束日期
        leave_start_date: '',
        // 离职日期开始日期
        leave_end_date: '',
        // 离职日期结束日期
        settlement_type: '',
        // 结算方式
        pay_method: '',
        // 发薪方式
        staff_ids: [],
        // 员工Id列表
        staff_state: [],
        // 员工在职状态
        staff_formal: [],
        // 员工属性
        // leave_end_date: '', // 离职截止日期
        department_ids: [],
        pay_date: '',
        // 发薪日期
        tax_deduction_status: '' // 税
      },

      ruleForm: {
        sub_project_name: [{
          required: true,
          message: this.$t('1019'),
          trigger: 'blur'
        } // 请输入子项目名称
        ],

        pay_month: [{
          required: true,
          message: this.$t('1018'),
          trigger: 'change'
        } // 请输入月份
        ],

        start_date: [{
          required: true,
          message: this.$t('839'),
          trigger: 'change'
        } // 请选择日期
        ],

        att_start_date: [{
          required: true,
          message: this.$t('839'),
          trigger: 'change'
        } // 请选择日期
        ],

        leave_start_date: [{
          required: true,
          message: this.$t('839'),
          trigger: 'change'
        } // 请选择日期
        ],

        settlement_type: [{
          required: true,
          message: this.$t('1011'),
          trigger: 'change'
        } // 请选择结算方式
        ],

        pay_method: [{
          required: true,
          message: this.$t('797'),
          trigger: 'change'
        } // 请选择发薪方式
        ],

        pay_date: [{
          required: true,
          message: this.$t('839'),
          trigger: 'change'
        }]
      },
      secondForm: {
        staff_state: [{
          required: true,
          message: this.$t('799'),
          trigger: 'change'
        } // 请选择员工状态
        ],

        leave_end_date: [{
          required: true,
          message: this.$t('1014'),
          trigger: 'change'
        } // 请选择离职日期
        ],

        staff_formal: [{
          required: true,
          message: this.$t('800'),
          trigger: 'change'
        }],
        tax_deduction_status: [{
          required: true,
          message: this.$t('basic_info_12'),
          trigger: 'change'
        }]
      }
    };
  },
  props: ['projectId'],
  methods: {
    init: function init() {
      this.sysInfoFn();
      this.activeItem = 1;
      this.visible = true;
    },
    // 获取选项
    sysInfoFn: function sysInfoFn() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _sysInfoFn();
            case 2:
              res = _context.sent;
              if (res && res.code === 1) _this2.sysInfo = res.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 打开选择人员弹窗
    openOrg: function openOrg() {
      this.orgVisible = true;
    },
    handleFormal: function handleFormal() {
      if (!this.form.tax_deduction_status) this.form.tax_deduction_status = '3';
    },
    handleNext: function handleNext() {
      var _this3 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this3.activeItem = 2;
        }
      });
    },
    handlePrve: function handlePrve() {
      this.activeItem = 1;
    },
    handleLeaveDateChange: function handleLeaveDateChange(v) {
      if (v) {
        var _v = _slicedToArray(v, 2),
          start = _v[0],
          end = _v[1];
        this.form.leave_start_date = start;
        this.form.leave_end_date = end;
      } else {
        this.form.leave_start_date = '';
        this.form.leave_end_date = '';
      }
    },
    handleDateChange: function handleDateChange(v) {
      if (v) {
        var _v2 = _slicedToArray(v, 2),
          start = _v2[0],
          end = _v2[1];
        this.form.start_date = start;
        this.form.end_date = end;
      } else {
        this.form.start_date = '';
        this.form.end_date = '';
      }
    },
    handleAttDateChange: function handleAttDateChange(v) {
      if (v) {
        var _v3 = _slicedToArray(v, 2),
          start = _v3[0],
          end = _v3[1];
        this.form.att_start_date = start;
        this.form.att_end_date = end;
      } else {
        this.form.att_start_date = '';
        this.form.att_end_date = '';
      }
    },
    getSelectNode: function getSelectNode(data) {
      this.form.staff_ids = data.staff_list.map(function (item) {
        return item.staff_id;
      });
      this.form.department_ids = data.dept_list.map(function (item) {
        return item.department_id;
      });
      this.form.department_list = data.dept_list;
      this.form.staff_list = data.staff_list;
      // 已选文案
      var status = Array.isArray(data.dept_list);
      var staff = Array.isArray(this.form.staff_ids) ? this.form.staff_ids.length : 0;
      var count = 0;
      if (status) {
        var _iterator = _createForOfIteratorHelper(data.dept_list),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            count += item.staff_count;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      this.selectedLength = this.$t('179') + (count + staff);
    },
    handleClose: function handleClose() {
      if (this.$refs.dataForm) this.$refs.dataForm.resetFields();
      if (this.$refs.secondForm) this.$refs.secondForm.resetFields();
      this.form.staff_ids = '';
      this.form.department_ids = '';
      this.form.tax_deduction_status = ''; // 税
      this.form.staff_state = []; // 员工在职状态
      this.form.staff_formal = []; // 员工属性
      this.form.leave_end_date = []; // 离职日期结束日期
      this.date = ''; // 计薪周期开始日期
      this.attData = ''; // 考勤周期开始日期
      this.leaveData = ''; // 离职日期
      this.selectedLength = this.$t('179'); // 已选
    },
    doSubmit: function doSubmit() {
      var _this4 = this;
      if (this.form.staff_ids.length === 0 && this.form.department_ids.length === 0) {
        // 请选择员工
        this.$message.error(this.$t('925'));
        return false;
      }
      this.form.sub_project_name = this.form.sub_project_name.trim();
      this.$refs.secondForm.validate(function (valid) {
        if (valid) {
          _this4.loading = true;
          _this4.form.project_id = _this4.projectId;
          _this4.form.staff_ids = _this4.form.staff_ids.toString();
          _this4.form.department_ids = _this4.form.department_ids.toString();
          _this4.form.staff_state = _this4.form.staff_state.toString();
          // department_list字段和staff_list字段是前端展示需要使用，提交时不需要传给后端
          delete _this4.form.department_list;
          delete _this4.form.staff_list;
          payrollSubProjectCreate(_objectSpread(_objectSpread({}, _this4.form), {}, {
            staff_formal: _this4.form.staff_formal.join()
          })).then(function (res) {
            _this4.loading = false;
            _this4.disabled = false;
            if (res && res.code === 1) {
              _this4.visible = false;
              _this4.$emit('refreshTableData');
              _this4.handleClose();
              _this4.$message({
                type: 'success',
                message: _this4.$t('1015') // 子项目新增成功
              });
            }
          }).catch(function () {
            _this4.loading = false;
            _this4.visible = false;
            _this4.disabled = false;
          });
        } else {}
      });
    }
  }
};